import { render, staticRenderFns } from "./exam-paper.vue?vue&type=template&id=30ff4cc8&scoped=true&"
import script from "./exam-paper.vue?vue&type=script&lang=ts&"
export * from "./exam-paper.vue?vue&type=script&lang=ts&"
import style0 from "./exam-paper.vue?vue&type=style&index=0&id=30ff4cc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ff4cc8",
  null
  
)

export default component.exports